import { render, staticRenderFns } from "./RutaMonitoring.vue?vue&type=template&id=936d96ae&"
import script from "./RutaMonitoring.vue?vue&type=script&lang=js&"
export * from "./RutaMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports